import { render, staticRenderFns } from "./ExamResultGrade6.vue?vue&type=template&id=6040cdfc&scoped=true&"
import script from "./ExamResultGrade6.vue?vue&type=script&lang=js&"
export * from "./ExamResultGrade6.vue?vue&type=script&lang=js&"
import style0 from "./ExamResultGrade6.vue?vue&type=style&index=0&id=6040cdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040cdfc",
  null
  
)

export default component.exports